module.exports = __webpack_public_path__ + "fonts/group_63.svg";